import styled, {css} from 'styled-components'
import {ifProp} from 'styled-tools'
import {down, up} from "styled-breakpoints";
import {Input} from "reactstrap";


export const Flex = styled.div`
    display: flex;
    flex-direction: ${({direction = 'row'}) => direction};
    justify-content: ${({justify = 'flex-start'}) => justify};
    align-items: ${({align = 'stretch'}) => align};
    flex-wrap: ${({wrap = 'nowrap'}) => wrap};

    ${ifProp(
            'sm',
            css`
                ${down('md')} {
                    flex-direction: column;
                }
            `
    )}
`

/**
 * Grid components
 */

export const Grid = styled.div`
    display: grid;
    grid-template-columns: ${({$columns = "1fr"}) => $columns};
    grid-template-rows: ${({$rows = "auto"}) => $rows};
    gap: ${({$gap = "0"}) => $gap};
    align-items: ${({$align = "stretch"}) => $align};
    justify-items: ${({$justify = "stretch"}) => $justify};
    padding: ${({$padding = "0"}) => $padding};

    ${ifProp(
            "$sm",
            css`
                ${down("md")} {
                    display: flex;
                    flex-direction: column;
                    margin: 0 12%;
                }
            `
    )}
    ${down("sm")} {
        gap: 8px;
    }

    ${up("lg")} {
        gap: 24px;
    }

    ${up("xl")} {
        max-width: 1440px;
    }
`;


/**
 * Col (basic grid/flex column wrapper)
 */

export const Col = styled.div.attrs((props) => ({
    className: `col-span-${props?.$span || 1}`,
}))`
    ${({$span}) =>
            $span &&
            css`
                grid-column: span ${$span};
            `}
`;


export const CustomInput = styled(Input)`
    background-color: #f9f9f9;
    border: 1px solid #CCCCCC;
    gap: 10px;
    border-radius: 4px;
    padding: 12px;
    font-size: 14px;

    &:focus {
        color: var(--bs-body-color);
        border-color: #CCCCCC;

        background-color: #f9f9f9;
        outline: 0;
        box-shadow: none;
    }
`
export const TabPanelWrapper = styled.div`

    div {
        margin-bottom: -1px;
        font-weight: 500;
        text-align: center;
        border-bottom: 1px solid #F2F2F2;

        button {
            position: relative;
            flex-shrink: 0;
            user-select: none;
            white-space: nowrap;
            border-radius: 0.75rem;
            padding: 0 0 0.5rem;
            flex-grow: 1;

            ${up("md")} {
                font-size: 1rem;
                line-height: 1.5rem;
            }

            &:hover {
                color: var(--color-text-dark);
            }

            > span {
                gap: .5rem;
            }

            a {
                width: 100%;
                border-bottom-width: 2px;
                border-color: transparent;
                color: #808080;
                font-family: Archivo;
                font-weight: 600;
                font-size: 14px;
                line-height: 100%;
                letter-spacing: 0.48px;
                text-transform: capitalize;

            }

            .active-pill {
                position: absolute;
                inset: 0;
                background-color: var(--color-primary);
                width: 100%;
                left: 0;
                right: 0;
                z-index: 1;
                top: calc(100% - 6px);
                border-radius: 0;
                height: 6px;
            }

            ${up("md")} {
                border-radius: 1rem;
            }
        }
        button.active a{
            color: var(--color-text-slight-dark);
        }
    }

    li.active a {

    }
}
`